export default __webpack_public_path__ + "static/media/002-about-noun_success_1195075-1-1.4cbb1b61.webp";